module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_5010.3784b61e.png";